import { useAtomValue } from 'jotai';
import { state } from '~/storage';

export const useDebugMode = () => {
	const isDebugMode = useAtomValue(state.isDebugMode);

	const getName = (
		item: { name?: string | null | undefined; pr7: string } | undefined,
	): string | null | undefined => {
		if (!isDebugMode) {
			return item ? item?.name : undefined;
		}
		return item?.name ? `${item?.name} [${item.pr7}]` : undefined;
	};
	return { getName, isDebug: isDebugMode };
};
